export const cleanPathName = (pathName: string) => {
  const regexMerchant = /\/merchant\//g;
  const regexPublisher = /\/publisher\//g;

  return pathName.replace(regexMerchant, '/').replace(regexPublisher, '/');
};
